export const SET_MESSAGE_CONTENT = 'SET_MESSAGE_CONTENT';